// extracted by mini-css-extract-plugin
export default {"wrapper":"ShapesTabContent_wrapper__SrjFS"};